import { Divider } from '@material-ui/core';
import PageHeading from 'components/molecules/PageHeading';
import { EstimatorSheetContentModule } from 'modules/newOrder/components/EstimatorSheetContent';
import { OrderSummary } from 'packages/careem/checkout/components';
import DriverTip from 'packages/shared/checkout/components/DriverTip';
import OrderLoader from 'packages/shared/checkout/components/OrderLoader';
import { usePlaceOrder } from 'packages/shared/checkout/hooks/usePlaceOrder';
import { CheckoutContextProvider } from 'packages/shared/checkout/provider/CheckoutContextProvider';
import OrderFooter from 'packages/shared/newOrder/components/OrderFooter';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import PaymentMethod from './components/PaymentMethod';
import Promo from './components/Promo';

const StyledDivider = styled(Divider)`
  height: 0.5px;
  background-color: ${({ theme }) => theme.colors.paleLightGray} !important;
`;

export interface CheckoutProps {}

const Checkout: React.FC<CheckoutProps> = () => {
  const { t } = useTranslation();

  const { orderData, loaderRef, showLoader, handlePlaceOrderClick, handleLoaderComplete } = usePlaceOrder();

  return (
    <CheckoutContextProvider>
      <OrderLoader onAnimationComplete={handleLoaderComplete} ref={loaderRef} show={showLoader} />
      <PageHeading title={t('newOrderPage.lastStep', 'Last Step')} />
      <OrderSummary />
      <StyledDivider className="mb-4" />
      <DriverTip displayType="column" showNotNow />
      <StyledDivider />
      <Promo />
      <StyledDivider className="mb-2" />
      <EstimatorSheetContentModule isHideFootnote isShowAddMoreItems isItemsExpandable />
      <StyledDivider className="mt-4 mb-2" />
      <PaymentMethod />
      <OrderFooter
        hideEstimator
        hidePriceButton
        onClick={handlePlaceOrderClick}
        isDisabled={orderData === undefined}
        primaryButtonText={t('newOrderPage.placeOrder')}
      />
    </CheckoutContextProvider>
  );
};

export default Checkout;
